var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFollowUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139.5,148.9h-19.2c-3.2,0-5.9,2.6-5.9,5.9s2.6,5.9,5.9,5.9h19.2c3.2,0,5.9-2.6,5.9-5.9S142.7,148.9,139.5,148.9z  M95.2,148.9H28.7c-3.2,0-5.9,2.6-5.9,5.9s2.6,5.9,5.9,5.9h66.5c3.2,0,5.9-2.6,5.9-5.9S98.4,148.9,95.2,148.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M145.3,186.7h-107c-10.5,0-19-8.5-19-19V34.1c0-10.5,8.5-19,19-19h81.9c3.2,0,5.9,2.6,5.9,5.9s-2.6,5.9-5.9,5.9H38.2 c-4,0-7.3,3.3-7.3,7.3v133.5c0,4,3.3,7.3,7.3,7.3h107c4,0,7.3-3.3,7.3-7.3V90.5c0-3.2,2.6-5.9,5.9-5.9c3.2,0,5.9,2.6,5.9,5.9v77.2 C164.3,178.2,155.7,186.7,145.3,186.7L145.3,186.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M177.3,23.8l-7.7-7.7c-4.7-4.7-12.7-4.3-17.9,0.9L81.9,86.9l-14.2,38.8l38.8-14.1l69.8-69.8c2.4-2.4,3.8-5.4,4.1-8.6 C180.8,29.6,179.6,26.2,177.3,23.8L177.3,23.8z M100.1,101.4l-12.7,4.6L92,93.3l51.7-51.7l8,8.1L100.1,101.4L100.1,101.4z  M168.1,33.5l-8.1,8.1l-8-8.1l8-8c0.6-0.6,1.2-0.8,1.5-0.8l7.3,7.3C168.8,32.2,168.7,32.9,168.1,33.5L168.1,33.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowUp);
export default __webpack_public_path__ + "static/media/followUp.7e6298b2.svg";
export { ForwardRef as ReactComponent };